import CardDetails from 'app/components/AccordionCustom/CardDetails/CardDetails';

export default CardDetails;
